export const reportClientError = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(...args);
  }
};